import React from 'react';
import { Location } from '../components/sections/Location';
import { Reservation } from '../components/sections/Reservation';

export const VisitPage = () => {
  return (
    <div className="pt-24 md:pt-32 bg-charcoal">
      <Location />
      <Reservation />
    </div>
  );
};